export const GROUPS_MUST_BE_CREATED_MESSAGE =
  'Primero debes crear el grupo al que vas a asistir';

export const GROUP_SELECTION_REQUIRED_MESSAGE =
  'Selecciona el grupo al que asistirás';

export const SINGLE_GROUP_SELECTION_MESSAGE =
  'Solo puedes seleccionar un grupo por encuentro';

export function isNumberedEncounterType(encounterType) {
  return /^encuentro_\d+$/.test(String(encounterType || '').trim().toLowerCase());
}

export function requiresEncounterGroup(encounterType) {
  const normalizedEncounterType = String(encounterType || '').trim().toLowerCase();
  return isNumberedEncounterType(normalizedEncounterType) ||
    normalizedEncounterType === 'accion_incidencia';
}

export function getEncounterGroupValidationMessage(
  encounterType,
  availableGroups,
  selectedGroupIds
) {
  if (Array.isArray(selectedGroupIds) && selectedGroupIds.length > 1) {
    return SINGLE_GROUP_SELECTION_MESSAGE;
  }
  if (!requiresEncounterGroup(encounterType)) return '';
  if (!Array.isArray(availableGroups) || availableGroups.length === 0) {
    return GROUPS_MUST_BE_CREATED_MESSAGE;
  }
  if (!Array.isArray(selectedGroupIds) || selectedGroupIds.length === 0) {
    return GROUP_SELECTION_REQUIRED_MESSAGE;
  }
  return '';
}
